import Image from "next/legacy/image"
import { HTMLAttributes } from "react"
import StarRating from "../StarRating"

export interface IReview {
  reviewer: string
  title?: string
  content: string
  trustpilot?: boolean
  facebook?: boolean
  rating: string
}

interface IReviewCardProps extends HTMLAttributes<HTMLElement> {
  review: IReview
}

export default function ReviewCard({ review, className }: IReviewCardProps) {
  const { reviewer, content, title, trustpilot, facebook } = review
  const rating = parseInt(review.rating)

  return (
    <article
      className={
        "p-8 rounded-xl border border-blue7/10 bg-white text-black text-lg drop-shadow-card " +
        className
      }
    >
      <p className="mb-2.5 font-bold">{reviewer}</p>
      <div className="mb-6 flex items-center">
        <StarRating value={rating} className="mr-auto" />
        {trustpilot && (
          <Image
            className="object-contain"
            src="/icons/trust-pilot.svg"
            alt="trustpilot"
            height={26}
            width={108}
          />
        )}
        {facebook && (
          <Image
            className="object-contain"
            src="/icons/facebook.svg"
            alt="facebook"
            height={26}
            width={108}
          />
        )}
      </div>

      {title && (
        <h4 className="text-gray8 font-montserrat font-semibold text-xl">
          {title}
        </h4>
      )}
      <p className="text-gray7">{content}</p>
    </article>
  )
}
